import { render, staticRenderFns } from "./Push_Notification.vue?vue&type=template&id=1ed31a9d&"
import script from "./Push_Notification.vue?vue&type=script&lang=js&"
export * from "./Push_Notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports